<!--
    @项目跟踪-item
-->
<template>
	<div class="project_com_item">
		<div class="item_top">
			<div class="item_top_title">
				<span class="title">[{{data.sectionNum}}]</span>
				<span class="title">{{data.sectionName}}</span>
				<span class="tag" v-if="data.calculatetype">{{data.calculatetype|calculatetypeFilter}}</span>
				<span class="tag" v-if="data.purmethod">{{data.purmethod|purmethodFilter}}</span>
			</div>
			<div class="item_top_time">
				<span>历时{{durationTime}}天</span>
				<el-button type="text" @click="routerTo(data)">查看更多></el-button>
			</div>
		</div>
		<div class="my_padding">
			<div class="item_middle">
				<div>
					<p>
						<span class="item_subtitle" v-if="systemType=='GC'">招标人：</span>
						<span class="item_subtitle" v-if="systemType=='CG'">采购人：</span>
						<span class="item_subtitle" v-if="systemType=='CQ'||systemType=='GT'">出让人：</span>
						<span class="content">{{data.tendereeName|projectIsEmpty}}</span>
					</p>
					<p>
						<span class="item_subtitle" v-if="systemType=='CQ'||systemType=='GT'">竞得人：</span>
						<span class="item_subtitle" v-else>中标人：</span>
						<span class="content">{{data.supplierName|projectIsEmpty}}</span>
					</p>
				</div>
				<div>
					<p>
						<span class="item_subtitle" v-if="systemType=='GC'">招标代理：</span>
						<span class="item_subtitle" v-if="systemType=='CG'">采购代理：</span>
						<span class="item_subtitle" v-if="systemType=='CQ'||systemType=='GT'">经纪代理：</span>
						<span class="content">{{data.agencyName|projectIsEmpty}}</span>
					</p>
					<p>
						<span class="item_subtitle" v-if="systemType=='CQ'||systemType=='GT'">成交价：</span>
						<span class="item_subtitle" v-else>中标价：</span>
						<span class="content">{{data.bidmoney?data.bidmoney+'元':data.bidmoney|projectIsEmpty}}</span>
					</p>
				</div>
				<div>
					<p>
						<span class="item_subtitle" v-if="systemType=='CQ'||systemType=='GT'">限时竞价时间：</span>
						<span class="item_subtitle" v-else>开标时间：</span>
						<span class="content">{{data.bidopenTime|projectIsEmpty}}
							<div v-if="timeLater"></div>
							<i v-if="timeLater">{{timeLater=='今日开标'?timeLater:timeLater+'天后'}}</i>
						</span>
					</p>
					<p>
						<span class="item_subtitle">完结日期：</span>
						<span class="content">{{data.projectEndTime|projectIsEmpty}}</span>
					</p>
				</div>
			</div>
			<div class="item_bottom">
                <el-steps :active="data.activeNode">
                    <el-step v-for="(element,index) in projectObj.projectProgress" :key="index">
                        <template slot="icon">
                            <img v-if="element.state === 1" src="../assets/images/home/progress_blue.png" alt />
                            <span v-else-if="element.state === 0" class="nodeCircleBlue"><span></span></span>
                            <span v-else class="nodeCircleGrey"></span>
                            <span :style="{color:'rgba(0, 0, 0,'+ (element.state == -1?0.45:element.state == 0?0.85:1) +')'}">&nbsp;&nbsp;{{element.flownodeName}}</span>
                        </template>
                    </el-step>
                </el-steps>
				<!-- <div class="step_item" :class="classFn(item,i,data.projectProgress[data.projectProgress.length-1])" v-for="(item,i) in data.projectProgress" :key="i">
					<template v-if="item.name.indexOf('异常')==-1">
						<div class="line left_line"></div>
						<div class="item_temp" @mouseover="getStepData(data.bidId,item.projectState,item.completeState)" @mouseleave="leaveDom">
							<span class="my_icon el-icon-check" v-if="processHandle(item,data.projectProgress[data.projectProgress.length-1])=='pass'"></span>
							<span class="my_icon" v-else-if="processHandle(item,data.projectProgress[data.projectProgress.length-1])=='ing'">{{i+1}}</span>
							<span class="my_icon el-icon-arrow-right" v-else></span>
							<em>
								<span>{{item.name}}</span>
							</em>
							<div class="line right_line"></div>
							<div class="hover_div" v-show="isAsk">
								<div class="hover_bg" v-loading="loading">
									<div class="hover_con">
										<h3>{{item.name}}审批流程</h3>
										<div class="hover_item" v-for="(item,i) in approvealData" :key="i">
											<div class="hover_left">
												<span></span>
											</div>
											<div class="hover_right">
												<p class="title">{{item.taskName}}</p>
												<p>提交人：{{item.userName|projectIsEmpty}}</p>
												<p>办理状态：{{item.auditMsg|projectIsEmpty}}</p>
												<p>任务提交时间：{{item.excuteDate|projectIsEmpty}}</p>
												<p>任务创建时间：{{item.creationTime|projectIsEmpty}}</p>
												<p>提交用时：{{item.durationString|projectIsEmpty}}</p>
											</div>
										</div>
										<div class="hover_item hover_item_end">
											<div class="hover_left">
												<span></span>
											</div>
											<div class="hover_right">
												<p class="title">结束</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<div class="my_unusual" :class="processHandle(item,data.projectProgress[data.projectProgress.length-1])">
							<div class="line left_line"></div>
							<div class="item_temp" @mouseover="getStepData(data.bidId,item.projectState,item.completeState)" @mouseleave="leaveDom">
								<span class="my_icon el-icon-check" v-if="processHandle(item,data.projectProgress[data.projectProgress.length-1])=='pass'"></span>
								<span class="my_icon" v-else-if="processHandle(item,data.projectProgress[data.projectProgress.length-1])=='ing'">{{i+1}}</span>
								<span class="my_icon el-icon-arrow-right" v-else></span>
								<em>
									<span>{{item.name}}</span>
								</em>
								<div class="line right_line"></div>
								<div class="hover_div" v-show="isAsk">
									<div class="hover_bg" v-loading="loading">
										<div class="hover_con">
											<h3>{{item.name}}审批流程</h3>
											<div class="hover_item" v-for="(item,i) in approvealData" :key="i">
												<div class="hover_left">
													<span></span>
												</div>
												<div class="hover_right">
													<p class="title">{{item.taskName}}</p>
													<p>提交人：{{item.userName|projectIsEmpty}}</p>
													<p>办理状态：{{item.auditMsg|projectIsEmpty}}</p>
													<p>任务提交时间：{{item.excuteDate|projectIsEmpty}}</p>
													<p>任务创建时间：{{item.creationTime|projectIsEmpty}}</p>
													<p>提交用时：{{item.durationString|projectIsEmpty}}</p>
												</div>
											</div>
											<div class="hover_item hover_item_end">
												<div class="hover_left">
													<span></span>
												</div>
												<div class="hover_right">
													<p class="title">结束</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import {getNewTime, isIEBrowser} from '@/utils/index';
import {apiworkBenchIndexAuditDetails} from '@/server/project';
import {apijwtToJsgcProgress} from '@/server/common'
export default {
	props:{
		// 类型
		type:{
			type:Number,
			default:1
		},
		data:{
			type:Object,
			default:function(){
				return {};
			}
		},
		systemType:{
			type:String,
			default:'GC'
		}
	},
	data(){
		return {
			loading:false,
			approvealData:[],
			isAsk:false,
			isEnter:false
		}
	},
	mounted(){
		if($('.step_unusual')){
			$('.step_unusual').prev().find('.right_line').hide();
		}else{
			return;
		}
	},
	methods:{
		// 招标项目审批流程
		getStepData(bidId,projectState,completeState){
			if(this.systemType=='GT'&&(projectState=='20'||projectState=='40'||projectState=='60'||projectState=='80')){
				return;
			}else if(this.systemType=='CQ'&&(projectState=='20'||projectState=='40'||projectState=='60'||projectState=='80')){
				return;
			}else{
				if(completeState&&!this.isEnter){
					this.loading=true;
					apiworkBenchIndexAuditDetails({
						bidId,
						projectState,
						type:this.systemType
					}).then((res)=>{
						this.loading=false;
						const {data} = res;
						if(data.code=='1'){
							this.isAsk=true;
							this.isEnter=true;
							this.approvealData=data.data;
						}else{
							this.$alert(data.msg)
						}
					})
				}
			}
		},
		leaveDom(){
			this.isAsk=false;
			this.isEnter=false;
		},
		classFn(item,i,lastItem){
			// let temp=this.getMax();
			// if(item.completeState && (item.projectState<temp)){
			// 	return 'step_pass';
			// }else if(item.name.indexOf('异常')!=-1){
			// 	return 'step_unusual';
			// }else if(item.completeState && (item.projectState==temp)){
			// 	return 'step_ing';
			// }else{
			// 	return null;
			// }
			if(lastItem.abnormalState&&lastItem.name.indexOf('异常')!=-1){
				if(item.abnormalState&&item.name.indexOf('异常')!=-1){
					return 'step_ing';
				}
				if(item.completeState){
					return 'step_pass';
				}
			}else{
				if(item.completeState){
					if(item.completeState&&item.currentNode){
						return 'step_ing';
					}
					return 'step_pass';
				}
			}
		},
		// 更多请求地址
		apijwtToJsgcProgress(temp){
			apijwtToJsgcProgress(temp).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					addPanel('跟踪详情',data.data)
				}else{
					this.$alert(data.msg);
				}
			})
		},
		// 更多跳转
		routerTo(data){
			let temp={
				bidId:data.bidId,
				projectstate:data.buyprojectState,
				// title:data.field1
				title:'项目流程',
				field2:this.systemType
			}
			this.apijwtToJsgcProgress(temp);
		},
		processHandle(item,lastItem){
			// let temp=this.getMax();
			// if(item.completeState && (item.projectState<temp)){
			// 	return 'pass';
			// }else if(item.completeState && (item.projectState==temp)){
			// 	return 'ing';
			// }else{
			// 	return null;
			// }
			if(lastItem.abnormalState&&lastItem.name.indexOf('异常')!=-1){
				if(item.abnormalState&&item.name.indexOf('异常')!=-1){
					return 'ing';
				}
				if(item.completeState){
					return 'pass';
				}
			}else{
				if(item.completeState){
					if(item.completeState&&item.currentNode){
						return 'ing';
					}
					return 'pass';
				}
			}
		},
		// 获取completeState为ture的projectState最大值
		getMax(){
			// console.log(this.data.buyprojectState)
			let max = this.data.projectProgress[0].projectState;
			// let max = this.data.buyprojectState;
			for (let i = 0; i < this.data.projectProgress.length-1; i++) {
				if(this.data.projectProgress[i+1].completeState){
					max = Number(max) < Number(this.data.projectProgress[i+1].projectState) ? Number(this.data.projectProgress[i+1].projectState) : Number(max);
				}
			}
			return max;
		}
	},
	computed:{
		timeLater(){
			let timestamp=Date.parse(new Date(getNewTime()));
			let openTime=this.data.bidopenTime;
			if(openTime){
				// let openTimeStamp=1629497000000;
				let openTimeStamp="";
				if(isIEBrowser()){
					openTimeStamp=Date.parse(openTime.replace('-','/'));
				}else{
					openTimeStamp=Date.parse(openTime);
				}
				let temp=openTimeStamp-timestamp;
				if(temp==0){
					return '今日开标';
				}else if(temp>0){
					return Math.floor(temp/1000/60/60/24);
				}else{
					return false;
				}
			}else{
				return false;
			}
		},
		// 计算历时时间
		durationTime(){
			let timestamp=Date.parse(new Date(getNewTime()));
			let createDataTamp="";
			if(isIEBrowser()){
				createDataTamp=Date.parse(this.data.createDate.replace('-','/'));
			}else{
				createDataTamp=Date.parse(this.data.createDate);
			}
			if(this.data.projectEndTime){
				let projectEndTamp="";
				if(isIEBrowser()){
					projectEndTamp=Date.parse(this.data.projectEndTime.replace('-','/'));
				}else{
					projectEndTamp=Date.parse(this.data.projectEndTime);
				}
				return Math.ceil((projectEndTamp-createDataTamp)/1000/60/60/24);
			}else{
				return Math.ceil((timestamp-createDataTamp)/1000/60/60/24);
			}
		}
	}
}
</script>

<style lang="less" scoped>
.project_com_item{
	position: relative;
	background: rgba(239,243,246,.26);
	border-radius: 3px;
	border: 1px solid rgba(204,204,204,.28);
	.item_top{
		padding: 0 15px;
		height: 56px;
		background: #EFF3F6;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.title{
			color: #000000;
			font-size: 14px;
			font-weight: bold;
		}
		.tag{
			color: #1890FF;
			font-size: 12px;
			background: rgba(255, 255, 255, 0.6);
			margin-left: 8px;
			padding: 5px 8px 5px 20px;
			position: relative;
			&:after{
				content: '';
				width: 8px;
				height: 8px;
				position: absolute;
				border: 1px solid #1890FF;
				border-radius: 50%;
				left: 8px;
				top: 50%;
				transform: translate(0,-50%);
			}
		}
		.item_top_time{
			span{
				color: #000000;
				font-size: 14px;
				font-weight: bold;
				margin-right: 16px;
			}
		}
	}
	.my_padding{
		padding: 0 25px;
	}
	.item_middle{
		padding: 12px 25px;
		border-bottom: 1px solid rgba(0,0,0,.08);
		display: flex;
		justify-content: space-between;
		align-items: center;
		&>div{
			flex: 1;
			p{
				height: 48px;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				span{
					font-size: 14px;
					color: #000000;
				}
				.item_subtitle{
					display: inline-block;
					width: 100px;
					text-align: right;
				}
				.content{
					display: inline-block;
					width: calc(100% - 100px);
					display: flex;
					align-items: center;
					div{
						border-style: solid;
						border-width: 13px 12px 13px 0;
						border-color: transparent rgba(245, 107, 108, 0.1) transparent transparent;
						width: 0px;
						height: 0px;
						margin-left: 10px;
					}
					i{
						font-style: normal;
						font-size: 14px;
						color: #F56B6C;
						background: rgba(245, 107, 108, 0.1);
						padding: 5px 15px 5px 8px;
						border-top-right-radius: 20px;
						border-bottom-right-radius: 20px;
					}
				}
			}
		}
	}
	.item_bottom{
		padding: 14px 20px 16px 20px;
		height: 100px;
		display: flex;
		justify-content: flex-start;
		// align-items: center;
		position: relative;
		margin-top: 10px;
		.step_item{
			width: 120px;
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
			.item_temp{
				display: flex;
				flex-direction: column;
				align-items: center;
				&:hover .hover_div{
					display: block;
				}
				.hover_div{
					text-align: left;
					padding: 5px 0;
					display: none;
					position: absolute;
					left: 0px;
					top: 45px;
					z-index: 9999;
					color: #000000;
					.hover_bg{
						width: 428px;
						padding: 15px;
						border-radius: 5px;
						background: rgba(0,0,0,.7);
						max-height: 320px;
						overflow: auto;
						box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.4);
						.hover_con{
							background: #ffffff;
							border-radius: 5px;
							padding: 20px;
							h3{
								margin-bottom: 20px;
							}
							.hover_item{
								display: flex;
								height: 135px;
								padding: 0 20px 0 20px;
								position: relative;
								.hover_left{
									border-right: 1px solid #A6A6A6;
									position: relative;
									>span{
										display: inline-block;
										width: 16px;
										height: 16px;
										border-radius: 50%;
										background: #1890FF;
										position: absolute;
										left: -7px;
										top: -7px;
									}
								}
								.hover_right{
									margin-left: 30px;
									position: absolute;
									top: -7px;
									p{
										margin-bottom: 5px;
									}
									.title{
										color: #1890FF;
									}
								}
							}
							.hover_item_end{
								height: 1px;
							}
						}
					}
				}
			}
			.my_icon{
				width: 24px;
				height: 24px;
				border: 1px solid #CCCCCC;
				border-radius: 50%;
				text-align: center;
				line-height: 22px;
				position: relative;
			}
			em{
				font-style: normal;
				font-size: 14px;
				margin-top: 10px;
				cursor: pointer;
				position: relative;
			}
			.line{
				max-width: 42px;
				// width: 38px;
				width: calc(50% - 15px);
				height: 1px;
				position: absolute;
				top: 12px;
				border-bottom: 1px solid #CCCCCC;
			}
			.left_line{
				left: 0px;
			}
			.right_line{
				right: 0px;
			}
			&:nth-child(1){
				.left_line{
					display: none;
				}
			}
			&:last-child{
				.right_line{
					display: none;
				}
			}
		}
		.step_pass{
			.my_icon{
				border-color: #1890FF;
				color: #1890FF;
			}
			.line{
				border-color: #1890FF;
			}
		}
		.step_ing{
			.my_icon{
				border-color: #1890FF;
				background: #1890FF;
				color: #ffffff;
			}
			.line{
				border-color: #1890FF;
			}
		}
		.my_unusual{
			height: 100%;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
			.my_icon{
				width: 24px;
				height: 24px;
				border: 1px solid #CCCCCC;
				border-radius: 50%;
				text-align: center;
				line-height: 22px;
			}
			.line{
				max-width: 84px;
				width: 76px;
				// width: calc(100% - 30px);
				height: 1px;
				position: absolute;
				top: 12px;
				border-bottom: 1px dashed #CCCCCC;
				left: -40px;
			}
		}
		.pass{
			.my_icon{
				border-color: #1890FF;
				color: #1890FF;
			}
			.line{
				border-color: #1890FF;
			}
		}
		.ing{
			.my_icon{
				border-color: #1890FF;
				background: #1890FF;
				color: #ffffff;
			}
			.line{
				border-color: #1890FF;
			}
		}
	}
}
</style>
